import * as React from "react";
const SvgFiRrGalaxy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-galaxy_svg__a)">
      <path
        fill="#062147"
        d="M13.5 12a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 13.5 12M24 14.255c0 .682-.382 1.286-.998 1.577a1.72 1.72 0 0 1-1.839-.227c-.686-.563-1.492-1.02-2.449-1.386a8.9 8.9 0 0 1-.226 3.113c-.982 3.889-4.551 6.616-8.705 6.667h-.115a1.73 1.73 0 0 1-1.5-.998 1.72 1.72 0 0 1 .227-1.839c.563-.686 1.02-1.492 1.386-2.449a8.8 8.8 0 0 1-3.113-.226C2.743 17.496.001 13.901 0 9.745c0-.682.382-1.286.998-1.577a1.71 1.71 0 0 1 1.839.227c.686.563 1.492 1.02 2.449 1.386a8.9 8.9 0 0 1 .226-3.113C6.504 2.743 10.099.001 14.255 0c.682 0 1.286.382 1.577.998a1.72 1.72 0 0 1-.227 1.839c-.563.686-1.02 1.492-1.386 2.449a8.9 8.9 0 0 1 3.113.226c3.925.991 6.667 4.586 6.667 8.742zm-2.021-.545c-.223-3.004-2.272-5.535-5.136-6.258a6.8 6.8 0 0 0-3.032-.081 1.5 1.5 0 0 1-1.429-.472 1.52 1.52 0 0 1-.32-1.491c.413-1.316.955-2.431 1.649-3.388-3.004.223-5.535 2.272-6.258 5.136a6.8 6.8 0 0 0-.081 3.032 1.5 1.5 0 0 1-.472 1.429 1.53 1.53 0 0 1-1.491.32c-1.316-.413-2.431-.955-3.388-1.649.223 3.004 2.272 5.535 5.136 6.258a6.8 6.8 0 0 0 3.026.083 1.526 1.526 0 0 1 1.756 1.961c-.413 1.315-.953 2.428-1.646 3.383 3.014-.251 5.537-2.291 6.254-5.131a6.8 6.8 0 0 0 .081-3.032 1.5 1.5 0 0 1 .472-1.429 1.52 1.52 0 0 1 1.491-.32c1.316.413 2.431.955 3.388 1.649"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-galaxy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGalaxy;
